import { Action } from 'redux';
import { LockedDeviceInfo } from '@src/types/ControlLockMode';

export interface ControlsLockState {
  lockedControllers: LockedDeviceInfo[];
}

const initState: ControlsLockState = {
  lockedControllers: [],
};

export default (
  state: ControlsLockState = initState,
  action: Action<string> & ControlsLockState,
) => {
  const handlers: Record<string, () => ControlsLockState> = {
    SET_CONTROLS_LOCK: () => {
      const { type: _type, ...cleanAction } = action;
      return { ...state, ...cleanAction };
    },
  };

  if (action.type && handlers[action.type] !== undefined) {
    return handlers[action.type]();
  }

  return state;
};
